// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"2c4a0ae2","930":"1a83efbb"}[chunkId] + ".chunk.js";
};